import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { SOCIAL_MEDIA } from "common/constants/v2/Constants";

const siteName = {
    [SOCIAL_MEDIA.LINKED_IN]: "LinkedIn",
    [SOCIAL_MEDIA.FACEBOOK]: "Facebook",
    [SOCIAL_MEDIA.TWITTER]: "Twitter",
    [SOCIAL_MEDIA.APPLE]: "Apple"
};

class SocialButton extends React.Component {
    render() {
        const { site, onClick, linkSite } = this.props;
        const linkClassName = linkSite ? styles.link : styles.unlink;

        return (
            <button className={ `${ styles.socialButton } ${ linkClassName } ${ styles[site] }` } type="button" onClick={ onClick }>
                <div className={ styles.icon } />
                <div className={ styles.text }>{ this._text() }</div>
            </button>
        );
    }

    _text() {
        const { site, linkSite } = this.props;

        if (site === SOCIAL_MEDIA.TERMINAL) {
            return "I'm a Bloomberg Anywhere client";
        }

        return `${ linkSite ? "Sign in with " : "Unlink " } ${ siteName[site] }`;
    }
}

SocialButton.propTypes = {
    site: PropTypes.string.isRequired,
    linkSite: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default SocialButton;
